var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 2.41667C13.159 2.41667 15.9756 4.19167 17.3506 7C15.9756 9.80833 13.1673 11.5833 10.0007 11.5833C6.83398 11.5833 4.02565 9.80833 2.65065 7C4.02565 4.19167 6.84232 2.41667 10.0007 2.41667ZM10.0007 0.75C5.83398 0.75 2.27565 3.34167 0.833984 7C2.27565 10.6583 5.83398 13.25 10.0007 13.25C14.1673 13.25 17.7257 10.6583 19.1673 7C17.7257 3.34167 14.1673 0.75 10.0007 0.75ZM10.0007 4.91667C11.1507 4.91667 12.084 5.85 12.084 7C12.084 8.15 11.1507 9.08333 10.0007 9.08333C8.85065 9.08333 7.91732 8.15 7.91732 7C7.91732 5.85 8.85065 4.91667 10.0007 4.91667ZM10.0007 3.25C7.93398 3.25 6.25065 4.93333 6.25065 7C6.25065 9.06667 7.93398 10.75 10.0007 10.75C12.0673 10.75 13.7506 9.06667 13.7506 7C13.7506 4.93333 12.0673 3.25 10.0007 3.25Z",
    fill: "#A3AED0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.b11530278c2f48d86f3e9c5527751bfe.svg";
export { ForwardRef as ReactComponent };